<template>
  <div>
    <label class="v-label theme--light">{{ label }}</label>
    <editor-menu-bar
      class="text-editor"
      :editor="editor"
      v-slot="{ commands, isActive }"
    >
      <div class="text-editor__button-bar">
        <v-btn
          :class="{ 'is-active': isActive.bold() }"
          icon
          @click="commands.bold"
        >
          <v-icon>mdi-format-bold</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <v-icon>mdi-format-italic</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <v-icon>mdi-format-strikethrough-variant</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <v-icon>mdi-format-underline</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          <v-icon>mdi-format-header-1</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          <v-icon>mdi-format-header-2</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          <v-icon>mdi-format-header-3</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <v-icon>mdi-format-list-numbered</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          @click="commands.horizontal_rule"
        >
          <v-icon>mdi-drag-horizontal-variant</v-icon>
        </v-btn>

        <v-btn icon class="text-editor__button" @click="commands.undo">
          <v-icon>mdi-undo</v-icon>
        </v-btn>

        <v-btn icon class="text-editor__button" @click="commands.redo">
          <v-icon>mdi-redo</v-icon>
        </v-btn>

        <v-btn
          icon
          class="text-editor__button"
          @click="showDialogImage=true"
        >
          <v-icon>mdi-file-image</v-icon>
        </v-btn>
        <v-btn
          icon
          class="text-editor__button"
          @click="showDialogVideo=true"
        >
          <v-icon>mdi-file-video</v-icon>
        </v-btn>

        <v-dialog
          v-model="showDialogVideo"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              Anexar vídeo
            </v-card-title>
            <v-card-text>
              <div>Insira aqui o link do video.</div>
              <v-text-field dense v-model="srcVideo" hide-details></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="anexarVideo(commands.video)"
              >
                Anexar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showDialogImage"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              Anexar imagem
            </v-card-title>
            <v-card-text>
              <div>Insira aqui o link da imagem.</div>
              <v-text-field dense v-model="srcImage" hide-details></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="anexarImagem(commands.image)"
              >
                Anexar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </editor-menu-bar>
    <editor-content class="text-editor__text-area" :editor="editor" />
  </div>
</template>

<script>
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
  import {
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Italic,
    Image,
    Underline,
    History,
    Strike,
  } from 'tiptap-extensions';
  import Video from '../../extensions/Video';

  export default {
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        editor: null,
        showDialogImage: false,
        srcImage: null,
        showDialogVideo: false,
        srcVideo: null
      };
    },
    components: {
      EditorContent,
      EditorMenuBar,
    },
    watch: {
      value(newValue) {
        this.editor.setContent(newValue);
      },
    },
    methods: {
      anexarImagem(command) {
        const src = this.srcImage
        if (src !== null) {
          command({ src });
        }
        this.showDialogImage = false;
        this.srcImage = null
      },
      anexarVideo(commands) {
        const src = this.srcVideo
        if (src !== null) {
          commands({ src });
        }
        this.showDialogVideo = false;
        this.srcVideo = null
      },
      onUpdate(e) {
        this.$emit('input', e);
      },
    },
    mounted() {
      this.editor = new Editor({
        extensions: [
          new BulletList(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(),
          new History(),
          new Video(),
        ],
        content: this.value,
        onUpdate: ({ getHTML }) => {
          const newContent = getHTML();
          this.onUpdate(newContent);
        },
      });
    },
    setTextContent(e) {
      this.editor.setContent(e);
    },
    beforeDestroy() {
      this.editor.destroy();
    },
  };
</script>

<style lang="scss">
  * {
    &:focus {
      outline: none;
    }
  }
  .text-editor {
    margin-top: 5px;
    &__button-bar {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      border: 1px solid rgba(0, 0, 0, 0.42);
      border-radius: 5px 5px 0 0;
      @media screen and (max-width: 540px) {
        justify-content: center;
      }
    }
    &__text-area {
      position: relative;
      overflow: hidden;
      width: 100%;
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: rgba(0, 0, 0, 0.42);
      border-radius: 0 0 5px 5px;
      padding-bottom: 30px;
      .ProseMirror {
        min-height: 100px;
        padding: 10px;
        p {
          img {
            width: 250px;
            height: auto;
          }
        }
      }
    }
  }
</style>
